import React, { useEffect, useState } from 'react';
import ApiService from '../../api/ApiService';
import LocalDataService from '../../api/LocalDataService';

function GoogleCallback() {
  const [message, setMessage] = useState('正在验证 Google 授权…');
  const [state, setState] = useState('loading');

  useEffect(() => {
    const finishLogin = async () => {
      const params = new URLSearchParams(window.location.search);
      const code = params.get('code');
      const oauthState = params.get('state') || '';
      const oauthError = params.get('error');

      try {
        if (oauthError) throw new Error(`Google 授权已取消：${oauthError}`);
        if (!code) throw new Error('未收到 Google 授权码');

        const redirectUri = localStorage.getItem('canvasGoogleRedirectUri') || `${window.location.origin}/auth/google/callback`;
        const refCode = LocalDataService.loadData('ref') || '';
        const userInfo = await new ApiService().googleCallback(code, oauthState, refCode, '', redirectUri);
        if (!userInfo?.token) throw new Error('登录响应中缺少访问令牌');

        LocalDataService.set_user_data(userInfo);
        const redirectPath = localStorage.getItem('redirectAfterLogin') || '/';
        localStorage.removeItem('redirectAfterLogin');
        localStorage.removeItem('canvasGoogleRedirectUri');
        setState('success');
        setMessage('登录成功，正在进入画布…');
        window.setTimeout(() => window.location.replace(`/#${redirectPath}`), 350);
      } catch (error) {
        console.error('Google OAuth 回调失败', error);
        setState('error');
        setMessage(error.message || 'Google 登录失败');
        window.setTimeout(() => window.location.replace('/#/login'), 2500);
      }
    };

    finishLogin();
  }, []);

  return (
    <main className={`canvas-auth-callback canvas-auth-callback-${state}`}>
      <div className="canvas-auth-callback-mark">{state === 'success' ? '✓' : state === 'error' ? '!' : '剧'}</div>
      <h1>{message}</h1>
    </main>
  );
}

export default GoogleCallback;
